import React from 'react';
import styled from 'styled-components';
import { Container, FlexboxGrid, Affix } from 'rsuite';

import ActionButtons from './ActionButtons';

const StyledAffix = styled(Affix)`
  color: white;
  > div {
    background-color: #5d9adf;
    padding: 10px 0;
  }
`;

const StyledHeaderContainer = styled(Container)`
  margin: 0 auto;
  padding: 0 10px;
  max-width: 950px;
`;

function PosHeader() {
  return (
    <StyledAffix>
      <StyledHeaderContainer>
        <FlexboxGrid align="middle" justify="space-between">
          <FlexboxGrid.Item colSpan={12}>
            <h5>POS</h5>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item colSpan={12}>
            <ActionButtons />
          </FlexboxGrid.Item>
        </FlexboxGrid>
      </StyledHeaderContainer>
    </StyledAffix>
  );
}

export default PosHeader;
